import { Component, OnInit, Injector } from '@angular/core';
import { OrganizationLocationService } from 'app/core/http/services/organization-location.service';
import { PractitionerOrganizationAffiliationService } from 'app/core/http/services/practititoner-organization-affiliation.service';
import { paginationI, paginationInitialState, tabI } from 'app/core/interfaces/layout';
import { organizationI } from 'app/core/interfaces/organization';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { PractitionerOrganizationDetailsComponent } from './details/organization-details.component';
import { PractitionerOrganizationLinkComponent } from './bond/organization-link.component';
import {  Location } from 'app/core/interfaces/location';

@Component({
  selector: 'src-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.scss'],
})
export class PractitionerOrganizationComponent extends BaseComponent implements OnInit {
  public organizations: organizationI[] = [];
  public title = 'Instituições';
  public tabs: tabI[] = [];
  public pagination: paginationI = paginationInitialState;

  public organizationActive: organizationI[] = [];
  public organizationInactive: organizationI[] = [];
  public organizationWaiting: organizationI[] = [];

  public organizationActivePaginated: any[] = [];
  public organizationInactivePaginated: organizationI[] = [];
  public organizationWaitingPaginated: organizationI[] = [];

  public nextLatLong: [number, number] = [0, 0];
  public locations: any[] = [];
  public affiliations: any[] = [];

  public practitionerLogged: any = {};

  public location !: Location

  constructor(
    private injector: Injector,
    private locationService: OrganizationLocationService,
    private AffiliationService: PractitionerOrganizationAffiliationService
  ) {
    super(injector);
    this.initTabs();
  }

  async ngOnInit() {
    this.practitionerLogged = this.getUserLogged();

    await this.getAffiliations();

    this.getLocations();
  }

   transformFhirToModel(jsonData: any[]) {
    const transformedFhir = jsonData.map((item) => {
      const {
        affiliation_id,
        request: { id: practitioner_id, display: practitioner_name, photo: practitioner_photo, details: practitioner_details },
        subject: { id: organization_id, display: organization_name, photo: organization_photo, address: address},
        specialty: specialty,
        status,
      } = item;

      return {
        affiliation_id,
        practitioner_name,
        practitioner_id,
        organization_name,
        organization_id,
        specialty,
        practitioner_photo,
        organization_photo,
        address,
        practitioner_details,
        status
      };
    });

    return transformedFhir;
  }

  async getAffiliations() {
    const practitioner_id = this.currentUser.user.id;

    this.AffiliationService.listByPractitioner(practitioner_id).subscribe({
      next: (resAffiliations: any) => {
        this.affiliations = this.transformFhirToModel(resAffiliations);

        this.getOrganizationsActive();
        this.getOrganizationsWaiting();
        this.getOrganizationsInactive();
      },
      error: (err) => {
        console.log('erro', err);
      },
    });
  }

  asAffiliationStatus(value: any): 'accepted' | 'cancelled' | 'requested' {
    return value as 'accepted' | 'cancelled' | 'requested';
  }

  getSpecialtiesForOrganization(organizationId: string, type: 'accepted' | 'cancelled' | 'requested'): string {
    const affiliations = this.affiliations.filter((aff) => aff.organization_id === organizationId);
    const specialties = affiliations.flatMap((aff) => aff.specialty.filter((s: any) => s.status === type)).map((s: any) => s.display);

    return specialties.length > 0 ? specialties.join(', ') : 'Sem Especialidades';
  }

  getLocations() {
    this.locationService.list().subscribe({
      next: (resLocation: any) => {
        this.locations = resLocation;
      },
      error: (err) => {
        console.log('erro', err);
      },
    });
  }

  getCity(organization_id: string) {


    const location = this.locations.find((location) => location.managingOrganization?.organization_id === organization_id);
    
    return `${location?.address[0]?.city}/${location?.address[0]?.state}` || null;
  }

  getAddress(organization_id: string) {
    const location = this.locations.find((location) => location.managingOrganization?.organization_id === organization_id);
    return location || null;
  }

  getOrganizationsActive() {
    const organizations = [...this.affiliations];

    this.organizationActive = organizations.filter((affiliation) => {
      return affiliation.specialty.some((specialty: any) => {
        return specialty.status === 'accepted';
      });
    });

    this.organizationActivePaginated = organizations.filter(
      (affiliation: any, index: number) =>
        affiliation.specialty.some((specialty: any) => {
          return specialty.status === 'accepted';
        }) && index <= this.pagination.limit * this.pagination.page
    );
  }

  getOrganizationsInactive() {
    const map = new Map<string, organizationI>();

    this.affiliations.forEach((affiliation) => {
      const cancelledSpecialties = affiliation.specialty.filter((specialty: any) => specialty.status === 'cancelled');
      if (cancelledSpecialties.length === 0) return;

      if (map.has(affiliation.organization_id)) {
        const existing: any = map.get(affiliation.organization_id)!;
        existing.specialty.push(...cancelledSpecialties);
      } else {
        map.set(affiliation.organization_id, {
          ...affiliation,
          specialty: [...cancelledSpecialties],
        });
      }
    });

    const grouped = Array.from(map.values());
    this.organizationInactive = grouped;
    this.organizationInactivePaginated = grouped.slice(0, this.pagination.limit * this.pagination.page);
  }

  getOrganizationsWaiting() {
    const organizations = [...this.affiliations];

    this.organizationWaiting = organizations.filter((affiliation) => {
      return affiliation.specialty.some((specialty: any) => {
        return specialty.status === 'requested';
      });
    });

    this.organizationWaitingPaginated = organizations.filter(
      (affiliation: any, index: number) =>
        affiliation.specialty.some((specialty: any) => {
          return specialty.status === 'requested';
        }) && index <= this.pagination.limit * this.pagination.page
    );
  }

  paginate(pagination: paginationI) {
    this.pagination = pagination;
    this.getOrganizationsActive();
    this.getOrganizationsInactive();
    this.getOrganizationsWaiting();
  }

  async openOrganizationDetailForm(organization: any, type?: string) {
    await this.getOrganizationLocation(organization);

    const data = {
      title: organization.organization_name,

      param: {
        type: type,
        affiliations: organization,
        location: this.location,
        latLong: this.nextLatLong,
      },
    };

    this.dialog.openMediumComponentDialog(PractitionerOrganizationDetailsComponent, data);
  }

  getOrganizationLocation(organization: any): Promise<void> {
    return new Promise((resolve, reject) => {
      const organizationId = organization.organization_id;

      this.locationService.showByOrganization(organizationId).subscribe({
        next: (resOrganizationLocation: Location) => {
          this.location = resOrganizationLocation
          this.nextLatLong = [resOrganizationLocation.position.latitude ?? 0, resOrganizationLocation.position.longitude ?? 0];
          resolve();
        },
        error: (err) => {
          console.log(err);
          reject(err);
        },
      });
    });
  }

  openOrganizationLinkForm() {
    const data = {
      title: 'Vincular nova instituição',
      param: { location: this.locations, affiliations: this.affiliations },
    };

    this.dialog.openComponentDialog(PractitionerOrganizationLinkComponent, data);
  }

  getContent(tabId: number) {
    switch (tabId) {
      case 2:
        return this.organizationInactive;
      case 3:
        return this.organizationWaiting;
      default:
        return this.organizationActive;
    }
  }

  getContentPaginated(tabId: number) {
    switch (tabId) {
      case 2:
        return this.organizationInactivePaginated;
      case 3:
        return this.organizationWaitingPaginated;
      default:
        return this.organizationActivePaginated;
    }
  }

  showPagination(tabId: number) {
    const list = this.getContent(tabId);
    return list.length > this.pagination.limit * this.pagination.page;
  }

  initTabs() {
    this.tabs = [
      {
        id: 1,
        title: 'Ativas',
        type: 'accepted',
      },
      {
        id: 2,
        title: 'Inativas',
        type: 'cancelled',
      },
      {
        id: 3,
        title: 'Aguardando aprovação',
        type: 'requested',
      },
    ];
  }
}
